import { render, staticRenderFns } from "./Notifications.html?vue&type=template&id=7c29cee2&external"
import script from "./Notifications.js?vue&type=script&lang=js&external"
export * from "./Notifications.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports